import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const Document2IconSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 19 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.903 1.11948C11.8024 1.01765 11.6643 0.978365 11.5273 0.963867H4.08984C2.33219 0.963867 0.902344 2.39371 0.902344 4.15137V17.9639C0.902344 19.7215 2.33219 21.1514 4.08984 21.1514H14.7148C16.4725 21.1514 17.9023 19.7215 17.9023 17.9639V7.33887C17.8868 7.20229 17.8491 7.06361 17.7467 6.96322L11.903 1.11948ZM12.0586 2.77755L16.0887 6.80768H14.1837C13.0119 6.80768 12.0587 5.8544 12.0587 4.68268L12.0586 2.77755ZM16.8399 17.9639C16.8399 19.1359 15.8866 20.0889 14.7149 20.0889H4.08985C2.91812 20.0889 1.96485 19.1359 1.96485 17.9639V4.15143C1.96485 2.9797 2.91812 2.02643 4.08985 2.02643H10.9961V4.68268C10.9961 6.44034 12.4259 7.87018 14.1836 7.87018H16.8399V17.9639Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='0.2'
    />
    <path
      d='M3.48608 11.3782C3.48608 11.6718 3.72393 11.9094 4.01733 11.9094H14.6423C14.9357 11.9094 15.1736 11.6718 15.1736 11.3782C15.1736 11.0845 14.9357 10.8469 14.6423 10.8469H4.01733C3.72394 10.8469 3.48608 11.0845 3.48608 11.3782Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='0.2'
    />
    <path
      d='M14.6405 13.5032H4.01548C3.31976 13.514 3.31511 14.5538 4.01548 14.5657H14.6405C15.3354 14.555 15.3415 13.5151 14.6405 13.5032Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='0.2'
    />
    <path
      d='M14.6405 16.1584H4.01548C3.31976 16.1693 3.31511 17.2091 4.01548 17.2209H14.6405C15.3354 17.2103 15.3415 16.1704 14.6405 16.1584Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='0.2'
    />
    <path
      d='M4.34077 4.85229C4.34077 4.60377 4.54224 4.40229 4.79077 4.40229H8.56776C8.81629 4.40229 9.01776 4.60377 9.01776 4.85229V8.62929C9.01776 8.87781 8.81629 9.07929 8.56776 9.07929H4.79077C4.54224 9.07929 4.34077 8.87781 4.34077 8.62929V4.85229Z'
      stroke='currentColor'
      strokeWidth='1.1'
      strokeLinejoin='round'
    />
  </svg>
);

export const Document2Icon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Document2IconSvg} {...props} />
);
